<template>
  <div class="status-page-wrapper">
    <header class="header">
      <img src="../assets/tatusq.png" width="50" />
      <span>Tatu na Grota</span>
    </header>
    
    <main class="status-container">
      
      <div v-if="loading" class="status-card loading">
        <span class="material-icons-outlined icon-loading">hourglass_top</span>
        <h2>Buscando seu pedido...</h2>
        <p>Aguarde um instante, estamos confirmando os dados.</p>
      </div>
      
      <div v-else-if="status === 'delivered'" class="status-card delivered">
        <div class="icon-wrapper delivered-icon">
          <span class="material-icons-outlined">inventory_2</span>
        </div>
        <h2>Pedido Entregue! 📦</h2>
        <p>Obrigado, <strong>{{ pedido.nome || 'cliente' }}</strong>!</p>
        <p>Seu pedido foi marcado como entregue. Esperamos que os ovos tenham chegado inteiros e frescos!</p>
        
        <div class="cta-box">
          <p>O que achou da experiência?</p>
          <button @click="irParaAvaliacao" class="btn-action btn-review">
            <span class="material-icons-outlined">star</span>
            Avaliar Compra
          </button>
        </div>
        
        <div class="order-summary simple">
          <p><strong>Pedido:</strong> #{{ pedido.id }}</p>
          <p>{{ pedido.produtoNome }} (x{{ pedido.quantidade }})</p>
        </div>
      </div>
      
      <div v-else-if="status === 'approved'" class="status-card success">
        <span class="material-icons-outlined icon-status">check_circle</span>
        <h2>Pagamento Confirmado!</h2>
        <p>Recebemos o pagamento, <strong>{{ pedido.nome || 'cliente' }}</strong>.</p>
        <p>Agora é só aguardar! Vamos preparar tudo para a entrega.</p>
        
        <div class="order-summary">
          <h3>Detalhes</h3>
          <p><strong>Pedido:</strong> #{{ pedido.id }}</p>
          <p><strong>Produto:</strong> {{ pedido.produtoNome || 'Produto' }} (x{{ pedido.quantidade }})</p>
          <p><strong>Valor:</strong> {{ pedido.valor_total | formatCurrency }}</p>
          <p><strong>Endereço:</strong> {{ pedido.endereco }}</p>
        </div>
        <p class="footer-note">Entraremos em contato se precisarmos de mais detalhes sobre o endereço. 🚚</p>
      </div>
      
      <div v-else-if="status === 'pending' || status === 'in_process'" class="status-card pending">
        <span class="material-icons-outlined icon-status">schedule</span>
        <h2>Pagamento Pendente</h2>
        <p>Estamos aguardando a confirmação do banco (Pix ou Boleto).</p>
        <p class="footer-note">Assim que for aprovado, esta tela será atualizada automaticamente.</p>
      </div>
      
      <div v-else-if="['rejected', 'failure', 'cancelled'].includes(status)" class="status-card failure">
        <span class="material-icons-outlined icon-status">error_outline</span>
        <h2>Pagamento não realizado</h2>
        <p>Houve um problema com o pagamento ou o pedido foi cancelado.</p>
        <p class="footer-note">Tente refazer a compra na página inicial.</p>
      </div>
      
      <div v-else class="status-card failure">
        <span class="material-icons-outlined icon-status">warning</span>
        <h2>Pedido não encontrado</h2>
        <p>{{ error || 'Verifique o link e tente novamente.' }}</p>
      </div>
      
      <div class="actions">
        <a href="#/" class="back-button-link">
          <span class="material-icons-outlined">storefront</span>
          Voltar para a Loja
        </a>
      </div>
    
    </main>
    
    <footer class="footer">
      <div class="footer-content">
        <p><strong>Chácara Tatu na Grota, Tucumã - PA</strong></p>
        <p>Dúvidas? <a href="https://wa.me/5594992435784">Chame no Zap</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: "StatusPedido",
  data() {
    return {
      loading: true,
      status: 'loading',
      pedido: null,
      error: null,
    };
  },
  filters: {
    formatCurrency(value) {
      if (typeof value !== "number") return "R$ 0,00";
      return "R$ " + value.toFixed(2).replace(".", ",");
    },
  },
  mounted() {
    this.processRedirect();
  },
  methods: {
    irParaAvaliacao() {
      if (this.pedido && this.pedido.external_reference) {
        this.$router.push(`/avaliar?ref=${this.pedido.external_reference}`);
      }
    },
    processRedirect() {
      const mpStatus = this.$route.query.collection_status || this.$route.query.status;
      const externalReference = this.$route.query.external_reference;
      
      if (!externalReference) {
        this.status = 'error';
        this.error = 'Link inválido (sem referência).';
        this.loading = false;
        return;
      }
      
      // Tratamento imediato de falha vindo do MP
      if (['rejected', 'failure', 'cancelled'].includes(mpStatus)) {
        this.status = 'rejected';
        this.loading = false;
        // Busca silenciosa para confirmar se existe
        this.fetchPedidoStatus(externalReference);
        return;
      }
      
      this.fetchPedidoStatus(externalReference);
    },
    
    async fetchPedidoStatus(externalReference) {
      this.loading = true;
      this.error = null;
      
      try {
        const res = await api.get(`/api/pedido/status/${externalReference}`);
        this.pedido = res.data;
        
        // Fonte da verdade é o banco
        this.status = this.pedido.status;
        
      } catch (err) {
        console.error("Erro ao buscar pedido:", err);
        this.status = 'error';
        if (err.response && err.response.status === 404) {
          this.error = "Pedido não encontrado no sistema.";
        } else {
          this.error = "Erro de conexão. Tente recarregar.";
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* --- Layout Global --- */
.status-page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-main);
  color: var(--text-main);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.header {
  padding: 10px;
  text-align: center;
  background-color: var(--bg-header);
  border-bottom: 1px solid var(--border-light);
  font-size: 1.3rem;
  font-weight: bold;
  color: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.status-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
}

/* --- Cards de Status --- */
.status-card {
  background-color: var(--bg-card);
  border-radius: 12px;
  padding: 30px 20px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  border-top: 6px solid transparent;
  text-align: center;
  animation: slideUp 0.4s ease-out;
}

.status-card h2 {
  font-size: 1.8rem;
  margin: 15px 0 10px;
  color: var(--text-hero);
}

.status-card p {
  font-size: 1.05rem;
  color: var(--text-secondary);
  margin-bottom: 5px;
  line-height: 1.5;
}

/* Ícones Gigantes */
.icon-status { font-size: 70px; margin-bottom: 10px; }
.icon-loading { font-size: 60px; color: var(--color-accent); animation: spin 1s linear infinite; }

/* Cores e Variações */
.status-card.success { border-color: #4CAF50; }
.status-card.success .icon-status { color: #4CAF50; }
.status-card.success h2 { color: #4CAF50; }

.status-card.pending { border-color: #FF9800; }
.status-card.pending .icon-status { color: #FF9800; }
.status-card.pending h2 { color: #FF9800; }

.status-card.failure { border-color: #F44336; }
.status-card.failure .icon-status { color: #F44336; }
.status-card.failure h2 { color: #F44336; }

.status-card.loading { border-color: var(--text-secondary); }

/* --- Estilo Exclusivo: DELIVERED --- */
.status-card.delivered {
  border-color: #8834f1; /* Roxo vibrante ou cor temática */
  background: linear-gradient(to bottom, var(--bg-card), var(--bg-main));
}
.delivered-icon {
  width: 80px; height: 80px;
  background-color: rgba(136, 52, 241, 0.1);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 15px;
}
.delivered-icon span {
  font-size: 40px; color: #8834f1;
}
.status-card.delivered h2 { color: #8834f1; }

/* CTA Box (Avaliação) */
.cta-box {
  margin: 25px 0;
  padding: 20px;
  background-color: var(--bg-main);
  border: 1px solid var(--border-light);
  border-radius: 8px;
}
.cta-box p { font-weight: 600; margin-bottom: 12px; color: var(--text-main); }

.btn-action {
  background-color: var(--color-button-buy);
  color: #fff;
  border: none; padding: 12px 24px;
  border-radius: 50px;
  font-size: 1rem; font-weight: bold;
  cursor: pointer;
  display: inline-flex; align-items: center; gap: 8px;
  transition: transform 0.2s, filter 0.2s;
  text-decoration: none;
}
.btn-action:hover { filter: brightness(1.1); transform: translateY(-2px); }
.btn-review { background-color: #FFD700; color: #3e2723; /* Dourado para avaliação */ }

/* Resumos */
.order-summary {
  background-color: var(--bg-main);
  border-radius: 8px; padding: 15px; margin-top: 20px;
  text-align: left; border: 1px solid var(--border-light);
}
.order-summary h3 { margin: 0 0 10px 0; font-size: 1rem; color: var(--text-hero); border-bottom: 1px solid var(--border-light); padding-bottom: 5px; }
.order-summary p { margin-bottom: 5px; font-size: 0.95rem; }

.order-summary.simple { text-align: center; border: none; background: transparent; margin-top: 10px; opacity: 0.8; }

/* Footer e Links */
.footer-note { font-size: 0.85rem; font-style: italic; margin-top: 15px; opacity: 0.7; }

.actions { margin-top: 30px; }
.back-button-link {
  color: var(--text-secondary); text-decoration: none; font-weight: 600;
  display: flex; align-items: center; gap: 5px; font-size: 0.9rem;
  transition: color 0.2s;
}
.back-button-link:hover { color: var(--color-accent); }

.footer { margin-top: auto; padding: 20px; border-top: 1px solid var(--border-light); text-align: center; font-size: 0.85rem; color: var(--text-secondary); }
.footer a { color: var(--color-accent); text-decoration: none; }

@keyframes spin { to { transform: rotate(360deg); } }
@keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>